import React, { ReactElement } from 'react';
import Kendra from 'aws-sdk/clients/kendra';
import _ from 'lodash';
import Checkbox from '@cloudscape-design/components/checkbox';

interface FacetCheckboxProps {
    attributeName: Kendra.DocumentAttributeKey;
    value: Kendra.DocumentAttributeValue;
    valueLabel: string;
    count?: number;

    selected: boolean;
    disableAdd: boolean;

    onSelectionChange: (
        key: Kendra.DocumentAttributeKey,
        value: Kendra.DocumentAttributeValue,
        changeDetail: boolean
    ) => void;

    facetConfiguration: {
        showCount: boolean;
    };
}

export const FacetCheckbox = ({
    attributeName,
    value,
    onSelectionChange,
    count,
    disableAdd,
    facetConfiguration,
    valueLabel,
    selected,
}: FacetCheckboxProps): ReactElement => {
    const handleChange = () => {
        onSelectionChange(attributeName, value, !selected);
    };

    const label: React.ReactNode =
        _.isNumber(count) && facetConfiguration.showCount ? (
            <span>
                {valueLabel}&nbsp;({count})
            </span>
        ) : (
            valueLabel
        );

    return (
        <div className="facet-checkbox">
            <Checkbox
                disabled={disableAdd && !selected}
                checked={selected}
                onChange={handleChange}
                data-testid="checkbox-label"
            >
                {label}
            </Checkbox>
        </div>
    );
};
